/**
 * API 端点定义
 * @module constants/api-endpoints
 */

export const API_ENDPOINTS = {
  // ============================================
  // 认证相关
  // ============================================
  AUTH: {
    /** 获取微信登录二维码 */
    GET_QR_CODE: '/api/ewm',
    /** 获取扫码 Token */
    CHECK_LOGIN: '/api/getToken',
    /** 发送验证码 */
    SEND_VERIFY_CODE: '/api/sms',
    /** 手机号登录 */
    PHONE_LOGIN: '/api/login_phone',
    /** 微信登录 */
    WECHAT_LOGIN: '/api/login/wechatLogin',
    /** 小程序登录 */
    MINI_PROGRAM_LOGIN: '/api/login/miniProgramLogin',
    /** 刷新 Token */
    REFRESH_TOKEN: '/api/login/refreshToken',
    /** 标准双 token 刷新会话 */
    REFRESH_SESSION: '/api/auth/refresh',
    /** 获取图片验证码 */
    GET_CAPTCHA: '/api/captcha',
    /** 获取滑块验证码 */
    GET_SLIDE_CAPTCHA: '/api/v3/captcha/slide',
    /** 发送验证码（带滑块验证） */
    SEND_VERIFY_CODE_WITH_SLIDE: '/api/v3/sms/slide',
    /** 小程序登录二维码 */
    MINI_PROGRAM_LOGIN_QR: '/api/wechat/applet/login-qrcode',
    /** 小程序二维码获取 Token */
    MINI_PROGRAM_GET_TOKEN_BY_QR: '/api/wechat/applet/get-token-by-qrcode',
    /** 小程序二维码获取登录参数 */
    MINI_PROGRAM_GET_LOGIN_PARAMS: '/api/wechat/applet/get-login-params',
    /** 小程序二维码绑定 Token */
    MINI_PROGRAM_BIND_TOKEN_BY_UUID: '/api/wechat/applet/bind-token-by-uuid',
    /** 小程序登录（旧版接口） */
    MINI_PROGRAM_LOGIN_LEGACY: '/api/wechat/applet/login',
    /** 设备号登录 */
    DEVICE_LOGIN: '/api/login_device',
    /** 创建 SSO code */
    CREATE_SSO_CODE: '/api/sso/create-code'
  },

  // ============================================
  // 用户相关
  // ============================================
  USER: {
    /** 获取用户信息 */
    INFO: '/api/mem_profile',
    /** 获取 VIP 信息 */
    VIP: '/api/license',
    /** 获取积分记录 */
    POINTS: '/api/user/points',
    /** 获取临时积分列表 */
    TEMP_POINTS: '/api/user_point_temp',
    /** 获取积分流水 */
    POINTS_LOG: '/api/user/points/log',
    /** 获取任务列表 */
    TASKS: '/api/user/tasks',
    /** 签到 */
    SIGN_IN: '/api/pointTask/signIn',
    /** 意见反馈 */
    FEEDBACK: '/api/report/feedback',
    /** 绑定手机 */
    BIND_PHONE: '/api/bind-phone',
    /** 绑定微信 */
    BIND_WECHAT: '/api/bind-wechat-qrcode',
    /** 任务调度 */
    TASK_SCHEDULE: '/api/pointTask/schedule',
    /** 激活码列表 */
    ACTIVATION_CODE_LIST: '/api/activation-code/activation_list',
    /** 用户积分记录列表 */
    POINT_GRANT_LIST: '/api/user_point_grant/list',
    /** 用户 Tokens 余额 */
    PRODUCT_TOKENS: '/api/user/productTokens'
  },

  // ============================================
  // 支付相关
  // ============================================
  PAYMENT: {
    /** 获取套餐列表 */
    GET_PACKAGES: '/api/price_plan',
    /** 获取 Token 套餐列表 */
    GET_TOKEN_PACKAGES: '/api/token_plan',
    /** 获取积分套餐列表 */
    GET_POINT_PACKAGES: '/api/point_plan',
    /** 获取用户 Tokens 余额 */
    GET_USER_TOKENS: '/api/user/productTokens',
    /** 获取订阅套餐列表 */
    GET_SUBSCRIBE_PACKAGES: '/api/order-subscribe',
    /** 取消订阅套餐 */
    CANCEL_SUBSCRIBE: '/api/order-subscribe',
    /** 创建订单 */
    CREATE_ORDER: '/api/order',
    /** 获取订单详情 */
    GET_ORDER_DETAIL: '/api/order',
    /** 获取支付二维码 */
    GET_PAYMENT_QR: '/api/wechat-qr',
    /** 验证支付 */
    CHECK_PAYMENT: '/api/verify-buy',
    /** 激活码兑换 */
    ACTIVATE_CODE: '/api/activation-code-active',
    /** 获取优惠券详情 */
    GET_COUPON: '/api/coupon-detail',
    /** 获取用户优惠券列表 */
    GET_USER_COUPONS: '/api/pay/getUserCoupons',
    /** 小程序支付配置 */
    MINI_PROGRAM_PAYMENT: '/api/wechat/applet/payConfig',
    /** 小程序虚拟支付配置 */
    MINI_PROGRAM_VIRTUAL_PAYMENT: '/api/wechat/applet/virtualPayConfig',
    /** 小程序支付 */
    MINI_PROGRAM_PAY: '/api/pay/miniProgramPay'
  },

  // ============================================
  // 产品信息
  // ============================================
  PRODUCT: {
    /** 获取产品信息 */
    INFO: '/api/product/info'
  },

  // ============================================
  // 事件相关
  // ============================================
  EVENT: {
    /** 事件上报 */
    REPORT: '/api/report/event',
    /** 百度回传 */
    BAIDU_REPORT: '/api/popularize/baidu',
    /** 获取配置 */
    GET_CONFIG: '/api/event/getConfig'
  }
} as const
